// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Dein Shop auf dem Handy',
    desktop: 'Dein Shop am Computer',
  },
  loading: 'Der Screenshot wird geladen',
  failed: 'Der Screenshot konnte nicht geladen werden.',
};
